import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { useTranslate, useDataProvider, usePermissions } from 'react-admin';
import { useHistory } from 'react-router-dom';
import Table from '../common/table';
import PageListLabel from '../page-list-label';
import { DeleteOutline, EditOutlined } from '@material-ui/icons';

const config = {
    headers: [
        { field: 'name', label: 'pos.devices.table_field.name', width: 2, bold: true },
        { field: 'description', label: 'pos.devices.table_field.description', width: 4 },
        { field: 'deviceAuthentication', label: 'pos.devices.table_field.device_authentication', width: 2 },
        { field: 'remoteControlType', label: 'pos.devices.table_field.remote_control_type', width: 1 },
        // { field: 'nativeApps', label: 'pos.devices.table_field.native_app', width: 1 },
    ],
    popupBodies: [
        { id: 1, label: 'pos.common.edit', icon: EditOutlined, hidden: true },
        { id: 2, label: 'pos.common.delete', icon: DeleteOutline, isDelete: true, hidden: true },
    ]
}

export default function DeviceProfiles() {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [deviceProfiles, setDeviceProfiles] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'DESC' },
    });

    const getListDeviceProfiles = () => {
        setLoading(true);
        dataProvider('GET_LIST', 'device-profile', {
            filter: {},
            // pagination: { page: 1, perPage: 100 },
            pagination: {},
            sort: {
                field: 'name',
                order: 'DESC'
            },
        }).then(({ data }) => {
            const deviceProfilesData = data.map(item => ({
                ...item,
                checked: false,
                remoteControlType: item.remoteControlType !== null ? item.remoteControlType.name : ""
            }));
            setDeviceProfiles({
                ...deviceProfiles,
                bodies: deviceProfilesData
            });
        }).catch(error => console.error('GET LIST DEVICE PROFILES ERROR:', error))
            .finally(() => setLoading(false));
    }

    const onCheck = (checkedItem) => {
        const newLists = deviceProfiles.bodies.map(item => ({
            ...item,
            checked: item.id === checkedItem.id ? !item.checked : item.checked
        }));

        setDeviceProfiles({
            ...deviceProfiles,
            bodies: newLists
        });
    }

    const onCheckAll = (isCheckedAll) => {
        const newLists = deviceProfiles.bodies.map(item => ({
            ...item,
            checked: !isCheckedAll
        }));
        setDeviceProfiles({
            ...deviceProfiles,
            bodies: newLists
        });
    }

    const onSort = (sortable) => {
        setDeviceProfiles({
            ...deviceProfiles,
            sortable
        });
    }

    const onActionMenuClick = (item, actionId) => {
        switch (actionId) {
            case 1:
                history.push('/DeviceProfiles/' + item.id);
                break;
            // case 2:
            //     onDelete([item.id]);
            //     break;
            default:
                break;
        }
    }

    // Sort list of movies
    useEffect(() => {
        const { field, order } = deviceProfiles.sortable;
        const newLists = deviceProfiles.bodies.sort((a, b) => {
            const valueA = a[field].toUpperCase();
            const valueB = b[field].toUpperCase();

            if (order === 'ASC') {
                if (valueA > valueB) return 1;
                else if (valueA < valueB) return -1;
            } else {
                if (valueA > valueB) return -1;
                else if (valueA < valueB) return 1;
            }
            return 0;
        });
        setDeviceProfiles({
            ...deviceProfiles,
            bodies: newLists
        });
    }, [deviceProfiles.sortable]);

    useEffect(() => {
        getListDeviceProfiles();
    }, []);

    if (!loaded) return null
    config.popupBodies.map(item => {
        item.hidden = !permissions.functionAction.find((value) => value.function === 'Devices and profiles' && value.isUpdate)
    })

    return (
        <Box mt={5} py={2} width="95%" m='auto'>
            <PageListLabel
                label={translate('pos.devices.title')}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'Devices and profiles' && value.isUpdate)
                }
                searchHidden={true}
                btnText={translate('pos.devices.createProfile')}
                // onChangeText={setSearchText}
                pathname='/DeviceProfiles/create'
                getList={getListDeviceProfiles}
                total={deviceProfiles.bodies.length}
            />

            <Table
                config={config}
                data={deviceProfiles}
                loading={loading}
                onCheck={onCheck}
                onCheckAll={onCheckAll}
                onSort={onSort}
                path={'DeviceProfiles'}
                onAction={onActionMenuClick}
                tableDelete={{
                    getList: getListDeviceProfiles,
                    setList: setDeviceProfiles,
                    urlDelete: 'device-profile'
                }}
                headerButtons={[
                    { id: '1', label: translate('pos.categories.Delete'), icon: <DeleteOutline />, isDelete: true },
                ]}
                disableClick={!permissions.functionAction.find(value => value.function === 'Devices and profiles' && value.isUpdate)}
            />
        </Box>
    )
}
